import { useState, ChangeEvent, useCallback } from "react"

interface UseHtmlInputData {
    value: string
    isValid: boolean
    onChange: (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void
    changeValue: (value: string) => void
}

export function useInput(
    initialValue: string,
    initialValid: boolean = true
): UseHtmlInputData {
    const [value, setValue] = useState(initialValue)
    const [isValid, setValid] = useState(initialValid)
    const handleChange = useCallback(
        (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            setValid(event.target.validity.valid)
            setValue(event.target.value)
        },
        []
    )

    return {
        value,
        isValid,
        onChange: handleChange,
        changeValue: (value: string) => setValue(value)
    }
}
